import { FC } from 'react';
import { Grid, Link } from '@material-ui/core';
import clsx from 'clsx';
import i18next from 'i18next';
import { useStyles } from '../../styles';
import mainLogo from '../../../../assets/logo/main.png';

const LogoAndBlogLink: FC = () => {
    const classes = useStyles();

    return (
        <Grid container direction="row" alignItems="flex-end">
            <Grid item>
                <img className={clsx(classes.logo)} src={mainLogo} alt="Logo" />
            </Grid>
            <Grid item>
                <Link
                    rel="noreferrer"
                    className={classes.blogLink}
                    target="_blank"
                    href="https://blog.gotmy.com/"
                >
                    {i18next.t('NavBarComponentBlog')}
                </Link>
            </Grid>
        </Grid>
    );
};

export default LogoAndBlogLink;
